import { render, staticRenderFns } from "./ChatResetConv.vue?vue&type=template&id=08b828c6&scoped=true&lang=pug&"
import script from "./ChatResetConv.vue?vue&type=script&lang=ts&"
export * from "./ChatResetConv.vue?vue&type=script&lang=ts&"
import style0 from "./ChatResetConv.vue?vue&type=style&index=0&id=08b828c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b828c6",
  null
  
)

export default component.exports